import React from 'react';

import { discoveryLinks, editableDiscoveryLinks, tagPresetsPath } from './utils';

const useDiscoveryLinks = () => {
  const [links, setLinks] = React.useState(discoveryLinks);

  React.useEffect(() => {
    let cancelled = false;

    async function loadLinks() {
      try {
        const response = await fetch(`/++api++${tagPresetsPath}`, {
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) return;

        const content = await response.json();
        const loadedLinks = editableDiscoveryLinks(content);
        if (!cancelled) setLinks(loadedLinks);
      } catch {
        // Keep the site usable if the optional editable tag preset page is absent.
      }
    }

    loadLinks();

    return () => {
      cancelled = true;
    };
  }, []);

  return links;
};

export default useDiscoveryLinks;
